module.exports = __webpack_public_path__ + "img/Margie Wilcox.8874d972.jpg";